import React from 'react'
import { LocationPaths } from 'location.types'
import { Navigate, RouteObject, useLocation } from 'react-router'

const LegacyOwnSensorRedirect = () => {
  const location = useLocation()

  return (
    <Navigate
      to={{
        pathname: LocationPaths.OwnSensorV2,
        search: location.search,
        hash: location.hash
      }}
      replace
    />
  )
}

export const legacyOwnSensorRedirect: RouteObject = {
  path: LocationPaths.LegacyOwnSensor,
  element: <LegacyOwnSensorRedirect />
}
